import { activeFilters } from 'utils/filters';
import { activeReport } from 'utils/report';
import { mergeIfPresent } from '../helpers';
import REST from '../rest';

const ENDPOINT = 'api/v1/feedbacks';

const queryParams = (params = {}, includeActiveFilters = true) => {
  let filterParams = {};
  filterParams = mergeIfPresent(filterParams, params.filter, (filters) => (filters));
  filterParams = mergeIfPresent(
    filterParams, activeReport(), (report) => ({ report_id: report.id }),
  );

  if (includeActiveFilters) {
    filterParams = mergeIfPresent(filterParams, activeFilters(), (filters) => (filters));
  }

  return mergeIfPresent({ ...params }, filterParams, (filter) => ({ filter }));
};

export const load = (params) => REST.get(ENDPOINT, '', queryParams(params));
export const loadAll = (params) => REST.get(ENDPOINT, '', queryParams(params, false));
export const get = (id) => REST.get(ENDPOINT, id, queryParams({ include: 'campaign' }));
